import { FormikProps } from "formik";
import { AddressForm } from "src/molecules/AddressForm";
import { AddressFormWrapper } from "./CheckoutForm.styled";
import type { Checkout } from "src/types/forms";

type CheckoutAddressFormProps = {
  formik: FormikProps<Checkout>;
  addressType: "shippingAddress" | "billingAddress";
};

function CheckoutAddressForm({
  formik,
  addressType,
}: CheckoutAddressFormProps): JSX.Element {
  return (
    <AddressFormWrapper>
      <AddressForm
        formik={formik}
        formikValuesAddress={formik.values[addressType]}
        formikErrorsAddress={formik.errors[addressType]}
        formikTouchedAddress={formik.touched[addressType]}
        type="checkout"
        addressType={addressType}
      />
    </AddressFormWrapper>
  );
}

export { CheckoutAddressForm };
